<template>
    <div class="page teacher-dashboard">
        <section  class="basic-wrap">
            <el-row :gutter="20">
             <el-col :span="6">
                    <div class="b-num">
                        <div class="b-num-left">
                            <el-progress :percentage="Math.round(planData.value*10000/100) ||0" type="circle" :width="70" color="#5CB85C"></el-progress>
                        </div>
                        <div class="b-num-right">
                            <div class="b-num-value">
                                <span class="b-num-mine1">{{planData.children[0] ||0}}</span>/<span class="b-num-all">{{planData.children[1] ||0}}</span>
                            </div>
                            <p class="b-num-name">{{$t('train.trainPlan')}}</p>
                        </div>
                    </div>
                </el-col>
             <el-col :span="6">
                    <div class="b-num">
                        <div class="b-num-left">
                            <el-progress :percentage="Math.round(paperData.value*10000)/100 ||0" type="circle" :width="70" color="#E46668"></el-progress>
                        </div>
                        <div class="b-num-right">
                            <div class="b-num-value">
                                <span class="b-num-mine3">{{paperData.children[0] ||0}}</span>/<span class="b-num-all">{{paperData.children[1] ||0}}</span>
                            </div>
                            <p class="b-num-name">{{$t('paper.paperLibrary')}}</p>
                        </div>
                    </div>
                </el-col>
             <el-col :span="6">
                    <div class="b-num">
                        <div class="b-num-left">
                            <el-progress :percentage="Math.round(courseData.value*10000)/100 ||0" type="circle" :width="70" color="#2e7faa"></el-progress>
                        </div>
                        <div class="b-num-right">
                            <div class="b-num-value">
                                <span class="b-num-mine4">{{courseData.children[0] ||0}}</span>/<span class="b-num-all">{{courseData.children[1] ||0}}</span>
                            </div>
                            <p class="b-num-name">{{$t('c.coursewareLibrary')}}</p>
                        </div>
                    </div>
                </el-col>
             <el-col :span="6">
                    <div class="b-num">
                        <div class="b-num-left">
                            <el-progress :percentage="Math.round(topicData.value*10000)/100 ||0" type="circle" :width="70" color="#ffb822"></el-progress>
                        </div>
                        <div class="b-num-right">
                            <div class="b-num-value">
                                <span class="b-num-mine5">{{topicData.children[0] ||0}}</span>/<span class="b-num-all">{{topicData.children[1] ||0}}</span>
                            </div>
                            <p class="b-num-name">{{$t('topic.examPaperLibrary')}}</p>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </section>
        <section>
            <el-row :gutter="20">
                <el-col :span="8">
                    <ui-card :title="$t('c.upTrend')" icon="nucfont inuc-line-chart1" class="ibox">
                        <div v-show="createRecentShow" id="createRecent" class="knowledgeBox"></div>
                        <p v-show="!createRecentShow" class="emptyBox"><i
                            class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                    </ui-card>
                </el-col>
                <el-col :span="10">
                    <ui-card :title="$t('c.trainAnalyse')" icon="nucfont inuc-line-chart1" class="ibox">
                        <div v-show="taskRecentShow" id="taskRecent" class="knowledgeBox"></div>
                        <p v-show="!taskRecentShow" class="emptyBox"><i
                            class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                    </ui-card>
                </el-col>
                <el-col :span="6">
                    <ui-card :title="$t('c.quickEntry')" icon="nucfont inuc-fenlei" class="ibox">
                        <div class="knowledgeBox" style="padding-top:10px;">
                            <p v-show="EntryData.length==0" class="emptyBox"><i
                                class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                            <el-row :gutter="20" class="quick-entry"  v-if="EntryData.length>0">
                                <el-col :span="8" class="q-entry-item" v-for="(item,index) in EntryData" :key="item.menuid">
                                    <div class="q-entry-icon" :class="'icon'+(index+1)"  @click="$router.push({path: item.path,params: {}})">
                                        <i class="nucfont" :class="item.iconclass || 'inuc-theory'"></i>
                                    </div>
                                    <span>{{item.name}}</span>
                                </el-col>
                            </el-row>
                        </div>
                    </ui-card>
                </el-col>
            </el-row>
        </section>
        <section class="train-wrap">
            <el-row :gutter="20">
                <el-col :span="18" class="col-flow">
                    <div class="ui-card ibox">
                        <div class="card-header">
                            <div class="card-icon"><i class="nucfont inuc-list-chart"></i></div>
                            <span class="card-title">{{$t('train.trainDetail')}}</span>
                            <span class="preview-more" @click="$router.push({name: 'trainPlan',params: {}})" style="float: right;padding-right: 20px;">{{$t('c.seeMore')}}>></span>
                        </div>
                        <div class="card-body">
                            <div class="train-list">
                                <ul class="train-list-recent">
                                    <li class="t-index">{{$t('c.NO')}}</li>
                                    <li class="t-name">{{$t('train.name')}}</li>
                                    <li class="t-type">{{$t('c.type')}}</li>
                                    <li class="t-name">{{$t('c.date')}}</li>
                                    <li class="t-type">{{$t('c.toEnd')}}</li>
                                    <li class="t-type">{{$t('c.status')}}</li>
                                    <li class="t-type">{{$t('c.operation')}}</li>
                                </ul>
                                <p v-show="planListData.length==0" class="emptyBox"><i
                                    class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                                <ul class="train-list-content" v-if="planListData.length>0">
                                    <li class="t-list-item" v-for="(item,index) in planListData" :key="item.id">
                                        <div class="t-index">{{index+1}}</div>
                                        <div class="t-name" :title="item.name">
                                            <span v-if="item.kind" style="float: left;">
                                                <i class="nucfont inuc-dingwei" style="color: #999;"></i>
                                            </span>
                                            {{item.name}}
                                        </div>
                                        <div class="t-type">{{item.typeName}}</div>
                                        <div class="t-name">{{item.duration}}</div>
                                        <div class="t-type"><span class="t-timeout" :class="deadLine(item)">{{item.outline}}</span></div>
                                        <div class="t-type"><span class="t-status">{{item.percent == null ? '-' : (Math.round(item.percent * 10000) / 100 + "%")}}</span></div>
                                        <div class="t-type">
                                            <!--<div class="btn-cell" @click="$router.push({name: 'trainPlanDetail',params: {planId: item.id}})">-->
                                            <div class="btn-cell" @click="viewTrainPlan(item)">
                                                <i class="nucfont inuc-preview"></i>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </el-col>
                <el-col :span="6" class="col-flow">
                    <ui-card :title="$t('c.trainFinish')" icon="nucfont inuc-pie-chart" class="ibox t-task-finish">
                        <div v-show="taskFinishShow" id="taskFinish" class="knowledgeBox3"></div>
                        <p v-show="!taskFinishShow" class="emptyBox"><i
                            class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                    </ui-card>
                </el-col>
            </el-row>
        </section>
    </div>
</template>

<script>
    import api from '@/api';
    import uiCard from '@/components/Statistics/StatisticUICard.vue';
    import StatisticsUploadTop from "@/components/Statistics/StatisticsUploadTop";
    var echarts = require('echarts');
    export default {
        data() {
            return {
                createRecentShow:true,
                taskRecentShow:true,
                taskFinishShow:true,
                recentChart:'',
                taskChart:'',
                taskFinishChart:'',
                planData:{
                    value:0,
                    children:[]
                },
                paperData:{
                    value:0,
                    children:[]
                },
                courseData:{
                    value:0,
                    children:[]
                },
                topicData:{
                    value:0,
                    children:[]
                },
                EntryData:[],
                planListData:[],
            }
        },

        created() {
        },
        mounted() {

            this.$nextTick(() => {
                this.query();
            });
        },
        watch:{

        },
        computed: {},
        methods: {
            query(){
                this.getBasicData();
                this.getCreateRecent();
                this.getTaskRecent();
                this.getFastEntry();
                this.getTaskList();
                this.getTaskFinish();
            },
            getBasicData(){
                api.getTraineeData().then(res=> {
                    let data = res.package;
                    this.planData=data[0];
                    this.paperData=data[1];
                    this.courseData=data[2];
                    this.topicData=data[3];
                })
            },

            getCreateRecent(){
                let recentChart = echarts.init(document.getElementById("createRecent"));
                //制定图标的配置项和数据
                recentChart.showLoading();

                api.getUploadRecent().then(res=> {
                    let data = res.package;
                    if(data){
                        if(data.xaxis.title.length>0){
                            this.createRecentShow=true;
                            let legendData = [this.$t('train.trainPlan'),this.$t('paper.paper'),this.$t('course.course')];
                            let seriesData=[];
                            data.series.forEach((value,idx) => {
                                seriesData.push({'name':legendData[idx],'type':'line','areaStyle': {},'data':value.data})
                            });
                            let xAxisData=[];
                            xAxisData=data.xaxis.title;
                            let option = {
                                color: ['#8BC2E1', '#5CB85C', '#FAD664'],
                                tooltip : {
                                    trigger: 'axis',
                                    axisPointer: {
//                                        type: 'cross',
                                        label: {
                                            backgroundColor: '#6a7985',
                                            formatter:function (params) {
//                                                params.value=this.$t('count.quantity');
                                                params.value='';
                                                return params.value
                                            }
                                        },

                                    }
                                },
                                legend: {
                                    data:legendData
                                },
                                xAxis : [
                                    {
                                        type : 'category',
                                        boundaryGap : false,
                                        data : xAxisData
                                    }
                                ],
                                yAxis : [
                                    {
                                        type : 'value'
                                    }
                                ],
                                series : seriesData
                            };
                            recentChart.hideLoading();
                            recentChart.setOption(option);
                            //根据窗口的大小变动图表 --- 重点
                            window.addEventListener('resize',function () {
                                recentChart.resize();
                            })
                        }else{
                            recentChart.hideLoading();
                            this.createRecentShow = false;
                        }

                    }else{
                        recentChart.hideLoading();
                        this.createRecentShow = false;
                    }

                })



            },
            getTaskRecent(){
                let taskChart = echarts.init(document.getElementById("taskRecent"));
                //制定图标的配置项和数据
                taskChart.showLoading();
//                this.taskRecentShow=true;
                api.getTaskAnalyse().then(res=> {
                    let data = res.package;
                    if(data){
                        if(data.xaxis.title.length>0){
                            let legendData = [this.$t('stu.trainTask'),this.$t('c.exam'),this.$t('c.learn')];
                            let seriesData=[];
                            data.series.forEach((value,index) => {
//                                legendData.push(value.name);
                                let yValue=[]
                                value.data.forEach((val,idx)=>{
                                    if(idx>0){
                                        yValue.push(val)
                                    }
                                })
                                seriesData.push({'name':legendData[index],'type':'bar','barMaxWidth':'10','data':yValue})
                            });
                            let xAxisData=[];
                            let xTitle=data.xaxis.title;
                            for(let i=1;i<xTitle.length;i++){
//                                let t=xTitle[i]+'-'+xTitle[i+1];
                                let t=xTitle[i];
                                xAxisData.push(t)
                            }
                            let option = {
                                color: ['#E4BC65', '#3AAFDA', '#A88873'],
                                tooltip : {
                                    trigger: 'axis',
                                    axisPointer: {
                                        type: 'shadow',
                                        label: {
                                            backgroundColor: '#6a7985',
                                            formatter:function (params) {
//                                                params.value=this.$t('count.quantity');
                                                params.value='';
                                                return params.value
                                            }
                                        }
                                    }
                                },
                                legend: {
                                    data:legendData
                                },
                                xAxis : [
                                    {
                                        type : 'category',
                                        axisTick: {show: true},
                                        axisLabel:{
                                            align:'left',
                                            padding:[0,0,0,25]
                                        },
                                        data : xAxisData
                                    }
                                ],
                                yAxis : [
                                    {
                                        type : 'value'
                                    }
                                ],
                                series : seriesData
                            };
                            taskChart.hideLoading();
                            taskChart.setOption(option);
                            this.taskRecentShow=true;
                            window.addEventListener('resize',function () {
                                taskChart.resize();
                            })
                        }else{
                            taskChart.hideLoading();
                            this.taskRecentShow = false;
                        }

                    }else{
                        taskChart.hideLoading();
                        this.taskRecentShow = false;
                    }

                })


            },
            getFastEntry(){
                api.getShortcutMenu().then(res=> {
                    let data = res.package;
                    this.EntryData=data;
                })
            },
            getTaskList(){
                api.getTrainList().then(res=> {
                    let data = res.package;
                    for (let i = 0; i < data.length; i++) {
                        data[i].duration = data[i].startTime.substring(0, 10) + " — "
                            + (data[i].endTime && data[i].endTime.substring(0, 10) || '');
                        if(data[i].deadline){
                            let day=data[i].deadline.split('d');
                            if(day[0]>=1){
                                data[i].outline=day[0]+this.$t('c.day')
                            }else{
                                let hour=day[1].split('h')
                                if(hour[0]>=1){
                                    data[i].outline=hour[0]+this.$t('c.hour')

                                }else{
                                    let minute=hour[1].split('m');
                                    data[i].outline=minute[0]+this.$t('exam.min')
                                }
                            }
                        }else{
                            data[i].outline='--'
                        }
                    }
                    this.planListData=data;

                })
            },
            getTaskFinish(){
                let taskFinishChart = echarts.init(document.getElementById("taskFinish"));
                //制定图标的配置项和数据
                taskFinishChart.showLoading();
//                this.createRecentShow=true;
                api.gettaskFinish().then(res=> {
                    let data = res.package;
                    if(data){
                        let num=0;
                        let legendData = [];
                        let seriesData=[];
                        data.forEach(value => {
                            legendData.push(value.name);
                            seriesData.push({'name':value.name,'value':value.value})
                            num +=value.value;
                        });
                        if(num > 0){
                            this.taskFinishShow = true;
                            let option = {
                                color: ['#2e7faa', '#0396a6', '#ffb822'],
                                tooltip : {
                                    trigger: 'item',
                                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                                },
                                legend: {
                                    data:legendData,
                                },
                                series : [
                                    {
                                        name:this.$t('count.quantity'),
                                        type: 'pie',
                                        radius : '55%',
                                        data:seriesData,
                                        itemStyle: {
                                            emphasis: {
                                                shadowBlur: 10,
                                                shadowOffsetX: 0,
                                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                                            }
                                        }
                                    },
                                ]
                            };
                            taskFinishChart.hideLoading();
                            taskFinishChart.setOption(option);
                            window.addEventListener('resize',function () {
                                taskFinishChart.resize();
                            })
                        }else{
                            taskFinishChart.hideLoading();
                            this.taskFinishShow = false;
                        }
                    }else{
                        taskFinishChart.hideLoading();
                        this.taskFinishShow = false;
                    }

                })

            },
            deadLine(item){
                let lineCss='';
                 if(item.deadline){
                    let day=item.deadline.split('d');
                      if(day[0]<4){
                          lineCss='red'
                      }else if(day[0]>=4 &&day[0]<8){
                          lineCss='yellow'
                      }
                  }

                 return lineCss
            },

            viewTrainPlan(data) {

                if (data.kind === 0) {
                    this.$router.push({name: 'trainPlanDetail',params: {planId: data.id}})
                } else if (data.kind === 1) {
                    this.$router.push({name: 'offlinePlanDetail',params: {planId: data.id}})
                }
                $('.app-main-inner').scrollTop(0)
            },
        },
        beforeRouteLeave (to, from, next) {
            if (to.name === 'trainPlanDetail' || to.name === 'offlinePlanDetail') {
                $('.app-main-inner').scrollTop(0);
            }
            next()
        },
        components: {
            uiCard,
            StatisticsUploadTop
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const';

    @include scrollbar(#999);
    .teacher-dashboard {
        overflow-y: auto;
    }

.basic-wrap{
    width: 100%;
    margin-bottom: 20px;

    .b-num{
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        height: 100px;
        padding: 15px 25px;
        box-shadow: 0 0 15px #e1e0d8;
        border-radius: 2px;
        .b-num-right{
            .b-num-value{
                font-size: 22px;
                line-height: 40px;
                .b-num-mine1{
                    color: #5CB85C;
                }
                .b-num-mine2{
                    color:#9F6FE7 ;
                }
                .b-num-mine3{
                    color:#E46668 ;
                }
                .b-num-mine4{
                    color:#2e7faa ;
                }
                .b-num-mine5{
                    color:#ffb822 ;
                }

                .b-num-all{
                    color: #ddd;
                }
            }
            .b-num-name{
                line-height: 1.6;
                float: right;
            }
        }
    }
}

.ibox {
    .content_detail-middle {
        padding: 30px;
        min-height: 300px;
    }
    .preview-more{
        cursor: pointer;
        &:hover{
            color: #2e7faa;
        }
    }
    .emptyBox {
        text-align: center;
        font-size: 18px;
        height: 250px;
        line-height: 250px;
    }
    &.t-task-finish{
        .emptyBox {
            height: 360px;
            line-height: 360px;
        }
    }
    .knowledgeBox {
        height: 250px;
        padding: 20px 0;
        margin: auto;
    }
    .train-list {
        height: 360px;
        overflow: hidden;
        /*padding: 20px 0;*/
        margin: auto;
        .train-list-recent {
            width: 100%;
            height: 52px;
            /*display: flex;*/
            /*justify-content: space-between;*/
            line-height: 52px;
            /*padding: 0 10px;*/
            > li {
                font-size: 16px;
                color: #252525;
                font-weight: bold;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .train-list-content{
            .t-list-item{
                height: 48px;
                line-height: 48px;
                &:nth-child(odd){
                    background-color: #faf9fc;
                }
                >div{
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .t-status{
                    display: inline-block;
                    width: 70px;
                    height: 24px;
                    line-height: 24px;
                    border-radius: 12px;
                    color: #fff;
                    background-color: #34bfa3;
                }
                .t-timeout{
                    display: inline-block;
                    width: 55px;
                    height: 24px;
                    line-height: 24px;
                    border-radius: 12px;

                    &.red{
                        color: #fff;
                        background-color:#f4516c ;
                    }
                    &.yellow{
                        color: #fff;
                        background-color:#ffb822 ;
                    }
                }
                .btn-cell i.nucfont {
                    padding: 0 5px;
                    font-size: 18px;
                    color: #a3a4a9;
                    -webkit-transition: all .3s;
                    transition: all .3s;
                    cursor: pointer;
                    &:hover{
                        color: #ffb822;
                    }
                }
            }
        }
        .t-index{
            display: inline-block;
            width: 6%;
        }
        .t-name{
            display: inline-block;
            width: 25%;
        }
        .t-type{
            display: inline-block;
            width: 10%;
        }
    }
    .knowledgeBox3 {
        height: 360px;
        padding: 20px 0;
        margin: auto;
    }


    .tg-bg {
        color: #fff;
        display: inline-block;
        min-width: 84px;
        text-align: center;
        &.blue {
            background-color: #2e7faa;
        }
        &.green {
            background-color: #0396a6;
        }
        &.gray {
            background-color: #8c7a6c;
        }
        &.yellow {
            background-color: #ffb822;
        }
        &.red {
            background-color: #f4516c;
        }
    }

}
.quick-entry{
        .q-entry-item{
            text-align: center;
            margin-top: 10px;
            cursor: pointer;
            .q-entry-icon{
                width: 46px;
                height: 46px;
                margin: 10px auto;
                color: #fff;
                padding-top: 11px;
                border-radius: 2px;
                >i{
                    font-size: 22px;
                }
                &.icon1{
                    background-color: #f4516c;
                }
                &.icon2{
                    background-color: #2e7faa;
                }
                &.icon3{
                     background-color: #A17E68;
                }
                &.icon4{
                    background-color: #0396a6;
                }
                &.icon5{
                    background-color: #ffb822;
                }
                &.icon6{
                     background-color: #9F6FE7;
                }
            }

            > span {
                height: 38px;
                display: inline-block;
            }
        }
    }

    .app-root:not(.lang-zh-CN) {
        .b-num-name {
            line-height: 22px!important;
        }
    }

    @media screen and (max-width: 1280px) {
        .el-col {
            padding-left: 5px!important;
            padding-right: 5px!important;
        }
        .ui-card {
            margin-bottom: 10px;
        }
        .quick-entry .q-entry-item > span {
            font-size: 12px;
        }
        .basic-wrap {
            margin-bottom: 10px;
            .b-num {
                padding: 15px;
                .b-num-name {
                    float: none!important;
                    text-align: center;
                }
            }
        }
        .train-wrap {
            .col-flow {
                width: 100%;
            }
        }
    }
</style>
